
<app-header></app-header>
<section style="margin-top:100px">  


  <div class="task-road">
<div [ngClass]="(user.aadharProof === 'approved' && user.kycStatus === 'approved') ? 'task completed' : 'task upcoming'">
  Sign Up & Verify  Get 25 Rs Worth CRED Coin<br/>
  <small>{{ (user.aadharProof === 'approved' && user.kycStatus === 'approved') ? 'Completed' : 'Upcoming' }}</small>
</div>

    <div class="connector"></div>
    <div class="task-wrapper">
      <div [ngClass]="txnHistory > 0 ? 'task completed' : 'task upcoming'">
        First Deposite<br/>
  <small>{{ txnHistory > 0 ? 'Completed' : 'Upcoming' }}</small>
</div>
    </div>
    <div class="connector"></div>
    <div class="task-wrapper">
      <div [ngClass]="tradeHistory > 0 ? 'task completed' : 'task upcoming'">
        First Trade<br/>
  <small>{{ tradeHistory > 0 ? 'Completed' : 'Upcoming' }}</small>
</div>
</div>
    <div class="connector"></div>

    <div class="task-wrapper">
      <div [ngClass]="refer? 'task completed' : 'task upcoming'">
        
        Refer a Friend & Get 25 Rs Worth CRED Coin<br/>
  <small>{{ refer > 0 ? 'Completed' : 'Upcoming' }}</small>
      </div>
    </div>

    <div class="connector"></div>

    <div class="task-wrapper">
      <div class="task upcoming">
        Stake atleast 2k worth Credcoins<br/><small>Upcoming</small>
      </div>
      <!-- <img src="https://inytesconnedwipdvfs.koinpark.com/ipfs/QmTtCpzm1pnqUD21whNZuJVmWywdeKmcqEGu47ryYHjkk5" alt="Upcoming" class="task-img">
    -->
    </div>
  </div>
  
  <div class="tab-pane active">
    <div class="container">
        <div class="image-grid">
            <img *ngFor="let image of imageUrls" [src]="image" alt="Crypto Image">
        </div>
    </div>
</div>

  <section style="margin-top:320px">
    <app-footer></app-footer>
</section>
 